import { useEffect } from 'react';
import { useOrderStore } from '../../../store/useOrder';
import { useLoginStore } from '../../../store/useLogin';
import { useFranchiseStore } from '../../../store/useFranchise';
import { useCustomerStore } from '../../../store/useCustomer';
import { useTracking } from '../../../store/useTracking';
import { get } from 'http';

/**
 * @author taulmax
 * @date 2024.11.16
 * @description 로그인 했을때 처음에 가져와야 하는 데이터
 */
const InitialResponse = () => {
  const { role } = useLoginStore();
  const { getContractStatus, getContractPromptStatus } = useOrderStore();
  const { getMyFranchise, getFranchise } = useFranchiseStore();
  const { getMyCustomer } = useCustomerStore();
  const { getTracking } = useTracking();

  // 어드민일 경우 주문 프롬프트 상태 조회
  useEffect(() => {
    if (role === 'ROLE_ADMIN') {
      getContractPromptStatus();
      getFranchise({ companyName: '', ceo: '', telNo: '' });
      getTracking();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  // 주문 상태 조회
  useEffect(() => {
    getContractStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 본인 가맹점 정보 가져오기
  useEffect(() => {
    getMyFranchise();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 본인 계정 정보 가져오기
  useEffect(() => {
    getMyCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default InitialResponse;
